import { BaseService } from "./baseService";
import httpRequest from ".";
import type { Page, CustomerBrowseProductRecordVo } from "@zhihaoscm/entity";

export class CustomerBrowseProductRecordService extends BaseService<unknown, unknown, any, any> {
    // 批量删除
    public async deleteCustomerBrowseProductRecordBatch(ids: number[]): Promise<any> {
        const { data } = await this.service.delete(`${this.path}/batch/delete`, {
            data: ids
        });

        return data;
    }

    // 分页查询
    public async customPaging(params: {
        page?: number;
        size?: number;
        keyword?: string;
        onlyHasStock?: boolean;
    }): Promise<Page<CustomerBrowseProductRecordVo>> {
        const { data } = await this.service.get(`${this.path}/custom-paging`, {
            params
        });

        return data;
    }

    // 清空
    public async clearCustomerBrowseProductRecord(): Promise<void> {
        const { data } = await this.service.delete(`${this.path}/clear`);

        return data;
    }
}

export const customerBrowseProductRecordService = new CustomerBrowseProductRecordService(
    "/customer-browse-product-record",
    httpRequest
);
